import React from 'react';
import { Dialog } from 'primereact/dialog';
import * as Fa from "react-icons/fa";

interface DynamicDialogProps {
    visible: boolean;
    onHide: () => void;
    message: string;
    confirmLabel?: string;
    cancelLabel?: string;
    onConfirm?: () => void;
    onCancel?: () => void;
    onhidevisible: boolean;
    ConfmDis?: boolean;
    title?: string;
    tone?: "info" | "success" | "warning" | "danger";
}

const ConfirmationPopUp: React.FC<DynamicDialogProps> = ({
    visible,
    onHide,
    message,
    confirmLabel,
    cancelLabel,
    onConfirm,
    onCancel,
    onhidevisible,
    ConfmDis = false,
    title = "Confirmation",
    tone = "info",
}) => {
    const toneStyles = {
        info: {
            icon: <Fa.FaInfoCircle />,
            headerBg: "linear-gradient(135deg, #1d4ed8, #2563eb)",
            iconBg: "#dbeafe",
            iconColor: "#1d4ed8",
            cardBorder: "#bfdbfe",
        },
        success: {
            icon: <Fa.FaCheckCircle />,
            headerBg: "linear-gradient(135deg, #047857, #10b981)",
            iconBg: "#d1fae5",
            iconColor: "#047857",
            cardBorder: "#a7f3d0",
        },
        warning: {
            icon: <Fa.FaExclamationTriangle />,
            headerBg: "linear-gradient(135deg, #b45309, #f59e0b)",
            iconBg: "#fef3c7",
            iconColor: "#b45309",
            cardBorder: "#fde68a",
        },
        danger: {
            icon: <Fa.FaTimesCircle />,
            headerBg: "linear-gradient(135deg, #b91c1c, #ef4444)",
            iconBg: "#fee2e2",
            iconColor: "#b91c1c",
            cardBorder: "#fecaca",
        },
    }[tone];

    const renderFooter = () => {
        if (confirmLabel && cancelLabel && onConfirm && onCancel) {
            return (
                <div className="confirmation-popup-footer">
                    <button type="button" disabled={ConfmDis} className="btn anime-btn" onClick={onConfirm}>
                        {confirmLabel} <Fa.FaCheck className="ms-2" />
                    </button>
                    <button type="button" className="btn anime-red-btn" onClick={onCancel}>
                        {cancelLabel} <Fa.FaTimes className="ms-2" />
                    </button>
                </div>
            );
        }
        if (confirmLabel && onConfirm) {
            return (
                <div className="confirmation-popup-footer">
                    <button type="button" className="btn anime-btn" onClick={onConfirm}>
                        {confirmLabel} <Fa.FaCheck className="ms-2" />
                    </button>
                </div>
            );
        }
        if (cancelLabel && onCancel) {
            return (
                <div className="confirmation-popup-footer">
                    <button type="button" className="btn anime-red-btn" onClick={onCancel}>
                        {cancelLabel} <Fa.FaTimes className="ms-2" />
                    </button>
                </div>
            );
        }

        return null;
    };

    return (
        <Dialog
            header={
                <div className="confirmation-popup-header">
                    <span className="confirmation-popup-header__icon" style={{ background: toneStyles.iconBg, color: toneStyles.iconColor }}>
                        {toneStyles.icon}
                    </span>
                    <span>{title}</span>
                </div>
            }
            visible={visible}
            style={{ width: "420px", maxWidth: "92vw" }}
            modal
            footer={renderFooter()}
            onHide={onHide}
            draggable={false}
            resizable={false}
            closable={onhidevisible}
            className="enhanced-confirmation-popup"
        >
            <div className="confirmation-popup-body" style={{ borderColor: toneStyles.cardBorder }}>
                <div className="confirmation-popup-body__icon" style={{ background: toneStyles.iconBg, color: toneStyles.iconColor }}>
                    {toneStyles.icon}
                </div>
                <div className="confirmation-popup-body__text">{message}</div>
            </div>
        </Dialog>
    );
};

export default ConfirmationPopUp;